import { Box, Divider, Heading, Text } from 'src/components/ui';
import { useContext } from 'react';
import UserContext from 'src/contexts/user/UserContext';
import { ICreative } from 'src/lib/schemas/campaign/newFlowCampaign';
import CreativeCard from './CreativeCard';
import { customToast } from 'src/services/toast';

interface EmailCreativeProps {
	creative: ICreative;
	withActions?: boolean;
	size?: string;
}

const EmailCreative = ({
	creative,
	withActions = true,
	size = 'md',
}: EmailCreativeProps) => {
	const { user } = useContext(UserContext);
	const subject = (creative as any).attributes.emailSubject;
	const body = (creative as any).attributes.plainEmailBody;

	const handleCopy = async () => {
		try {
			const emailContent = `Subject: ${subject}\n\n${body}`;
			await navigator.clipboard.writeText(emailContent);
			customToast('Email content copied to clipboard!', 'success');
		} catch (error) {
			customToast('Failed to copy content', 'error');
		}
	};

	return (
		<CreativeCard
			creative={creative}
			withActions={withActions}
			size={size}
			title="Email"
			onCopy={handleCopy}
		>
			<Box
				borderWidth="1px"
				borderRadius="lg"
				overflow="hidden"
				boxShadow="md"
				maxW="600px"
				bg="white"
				p={6}
			>
				<Box mb={4}>
					<Heading mb={2}>{subject}</Heading>
					<Text color="gray.500" fontSize="sm">
						From: {user?.email}
					</Text>
					<Text color="gray.500" fontSize="sm">
						To: john.doe@example.com
					</Text>
				</Box>
				<Divider />
				<Box
					data-testid="email-content"
					p={5}
					dangerouslySetInnerHTML={{
						__html: body,
					}}
				/>
			</Box>
		</CreativeCard>
	);
};

export default EmailCreative;
